<ng-container *transloco="let t">
    <div
        *ngIf="open"
        class="bazis-block bazis-block_shadow bazis-block_search"
        (clickOutside)="onClickOutside()"
        clickOutside
        [excludeElement]="toggleBtn.el"
    >
        <bazis-input-default
            [formControl]="searchControl"
            [rightIcon]="icons.search"
            isRightIconClickable="true"
            [noteKey]="noteKey"
            [tooltipKey]="tooltipKey"
            [noteParams]="noteParams"
            [tooltipParams]="tooltipParams"
            [tooltipSettings]="tooltipSettings"
            [sizeControl]="sizeControl"
            (touched)="markAsTouched()"
            (focused)="isSearchFocused = true"
            (blured)="isSearchFocused = false"
        >
        </bazis-input-default>
        <div
            class="bazis-options-content"
            scroll
            (scrollToBottom)="nextPage()"
            *ngIf="{
                list: formattedList$ | async
            } as data"
        >
            <ng-container *ngIf="data.list?.length === 0">
                {{ t(emptyListKey || 'title.emptyList') }}
            </ng-container>
            <bazis-input-options
                *ngIf="data.list?.length"
                [formControl]="selected"
                resetSelectionOnUpdateOptions="keepSelection"
                [selectAllKey]="
                    data.list?.length > selectAllTreshhold ? null : 'action.selectAllCount'
                "
                [options]="formattedList$ | async"
            ></bazis-input-options>
        </div>
        <ng-container *ngIf="showApplyButton">
            <div
                class="bazis-block__footer"
                *ngIf="selected.valueChanges | async"
            >
                <bazis-button
                    color="action"
                    (click)="apply()"
                >
                    {{ t(buttonApplyKey, { count: selected.value.length }) }}
                </bazis-button>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="{ statusChanges: ngControl.control.statusChanges | async } as data">
        <bazis-button
            [fill]="fillButton"
            color="action"
            [class.bh-hidden]="open"
            #toggleBtn
            [disabled]="ngControl.control.disabled"
            (click)="togglePopup()"
        >
            <bazis-icon
                slot="start"
                [name]="icons.plus"
            ></bazis-icon>
            {{ t(buttonOpenKey) }}
        </bazis-button>
    </ng-container>
</ng-container>
